export default {
    centerTemplate: {
        type: [String, Function],
        default: undefined
    },
    color: {
        type: String,
        default: undefined
    },
    colors: {
        type: Array,
        default: undefined
    },
    gaugeArea: {
        type: Object,
        default: undefined
    },
    opacity: {
        type: Number,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    scale: {
        type: Object,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined
    },
    value: {
        type: Number,
        default: undefined
    }

    // Events
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoArcGauge/ArcGaugeProps.js